module.exports = __webpack_public_path__ + "static/media/info-light.a35570fe.svg";